import {createStyles, Theme} from "@material-ui/core";
import {styleColors, typography} from "src/main.style";

export const SelectStyle = (theme: Theme) => createStyles({
    root: {
        minHeight: '40px',
        minWidth: 0,
        maxWidth: '100%',
        padding: theme.spacing(1, 2, 1, 1),
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        ...typography.input,
        boxSizing: 'border-box',
        backgroundColor: theme.palette.common.white,
        border: '1px solid',
        borderColor: theme.palette.common.black,
        borderRadius: '0.1875rem',
    },
    outlined: {
        paddingRight: theme.spacing(4),
        border: '1px solid',
        borderColor: theme.palette.common.black,
        borderRadius: '0.1875rem',

        // The select draws its own border. MUI's outline is a sibling, and its rounder
        // corners showed through as dots around the focused select.
        '& ~ fieldset': {
            display: 'none',
        },
        '.Mui-focused > &': {
            borderColor: styleColors.deepPurple,
        },
    },
    select: {
        backgroundColor: theme.palette.common.white,
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',

        '&:focus': {
            backgroundColor: theme.palette.common.white,
        },
    },
});

export const MenuStyle = (theme: Theme) => createStyles({
    paper: {
        marginTop: theme.spacing(1),
        backgroundColor: theme.palette.common.white,
        borderRadius: '0.1875rem',
        padding: 0,
        border: `1px solid ${styleColors.outlineBlack23}`,
        boxShadow: `0 6px 16px ${styleColors.blackAlpha23}, 0 2px 4px ${styleColors.blackAlpha12}`,
    },
    list: {
        maxHeight: '163px',
        overflowY: "auto",

        '& .MuiMenuItem-root': {
            ...typography.input,
            padding: theme.spacing(1, 2.75),
        }
    },
});

export const InputBaseStyle = (theme: Theme) => createStyles({
    root: {
        '& fieldset': {
            display: 'none',
        },
    },
});




// WEBPACK FOOTER //
// ./src/components/common/select/select.style.ts